/*
  Nature Lane Beauty — collection sort.

  The sort control is a plain GET form so it works with JavaScript switched
  off, where a fallback submit button does the work. When the script runs it
  removes that button and submits on change instead, which is the design's
  behaviour — a menu that acts on selection with nothing to press afterwards.

  Removing the button rather than hiding it matters: a hidden-but-present
  submit is still reachable by keyboard and still announced.
*/
(function () {
  'use strict';

  function initSortForm(form) {
    if (form.dataset.nlbSortReady === 'true') return;
    form.dataset.nlbSortReady = 'true';

    var select = form.querySelector('select');
    if (!select) return;

    var submit = form.querySelector('[data-nlb-sort-submit]');
    if (submit) submit.remove();

    select.addEventListener('change', function () {
      form.submit();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nlb-sort-form]').forEach(initSortForm);
  }

  init(document);

  // The theme editor re-renders a section without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
